module.exports = __webpack_public_path__ + "img/icon_weather_214.35762e58.svg";